import { render, staticRenderFns } from "./klarna-faqs.vue?vue&type=template&id=761ccf3a&scoped=true&"
import script from "./klarna-faqs.vue?vue&type=script&lang=js&"
export * from "./klarna-faqs.vue?vue&type=script&lang=js&"
import style0 from "./klarna-faqs.vue?vue&type=style&index=0&id=761ccf3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761ccf3a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SupportCategories: require('/opt/build/repo/storefront/components/legacy/support/support-categories.vue').default})
